/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { colors } from "../../components/colors";
import { CircleContainer } from "../../components/CircleContainer";
import { StyledText } from "../../assets/typography/typography";
import { Divider } from "../../components/Divider";
import { SmallButton } from "../../components/Buttons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { DropdownMenuWrapper } from "./DropdownMenuWrapper";

const innerWrapperStyle = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: start;
  align-items: center;
  padding: 8px 8px 0px 16px;
`;

const additionalStylingCircleContainer = css`
  border: 1px solid ${colors.ctaInactive};
`;

const menuWrapperStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const buttonWrapperStyle = css`
  padding: 0px 8px 8px 8px;
  width: 100%;
`;

const buttonStyle = css`
  display: flex;
  justify-content: start;
`;

interface Props {
  userDisplayName: string;
  menu: React.ReactNode;
  logOut: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const TopBarDropdownMenu = ({
  userDisplayName,
  menu,
  logOut,
}: Props) => {
  return (
    <DropdownMenuWrapper>
      <div css={innerWrapperStyle}>
        <CircleContainer
          width="32px"
          height="32px"
          backgroundColor={colors.white}
          additionalStyling={additionalStylingCircleContainer}
        >
          <CircleContainer
            width="24px"
            height="24px"
            backgroundColor={colors.ctaInactive}
          >
            <StyledText className="bodyTextSemibold mb-0">
              {userDisplayName.charAt(0).toUpperCase()}
            </StyledText>
          </CircleContainer>
        </CircleContainer>
        <StyledText
          className="bodyTextSemibold mb-0"
          color={colors.textPrimary}
        >
          {userDisplayName}
        </StyledText>
      </div>
      <Divider />
      <div css={menuWrapperStyle}>
        {React.cloneElement(menu as React.ReactElement, {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            boxShadow: "none",
            padding: "0px",
            backgroundColor: "transparent",
          },
        })}
      </div>
      <Divider />
      <div css={buttonWrapperStyle}>
        <SmallButton
          css={buttonStyle}
          icon={<FontAwesomeIcon icon={solid("right-from-bracket")} />}
          color={colors.errorDark}
          backgroundColor={colors.white}
          hoverColor={colors.errorLight}
          onClick={logOut}
          width="100%"
        >
          Log out
        </SmallButton>
      </div>
    </DropdownMenuWrapper>
  );
};
